const state = {
  myScoreID: '',
  myUID: '',
  myDisplayName: '',
  shareScoreID: ''
}

const getters = {
  getMyScoreID (state, getters, rootState) {
    return state.myScoreID
  },
  getMyUID (state, getters, rootState) {
    return state.myUID
  },
  getMyDisplayName (state, getters, rootState) {
    return state.myDisplayName
  },
  getShareScoreID (state, getters, rootState) {
    return state.shareScoreID
  }
}

const mutations = {
  setMyScoreID (state, val) {
    state.myScoreID = val
  },
  setMyUID (state, val) {
    state.myUID = val
  },
  setMyDisplayName (state, val) {
    state.myDisplayName = val
  },
  setShareScoreID (state, val) {
    state.shareScoreID = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  // actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/UserInfo.js